import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Specialities from "../../specialities/Specialities";
import ContactMarquee from "../ContactMarquee";

const Services = () => {
  return (
    <>
      <Helmet>
        <title>Columbiaa Hospital Services | Best Multi-Speciality Hospital in Kasturi Nagar Bangalore</title>
        <meta name="description" content="Columbiaa Hospital in Kasturi Nagar, Bangalore offers comprehensive medical services including 24x7 emergency care, critical care, dialysis, digital X-ray, advanced laboratory, insurance desk, and patient-friendly front desk. Best multi-speciality hospital with expert doctors." />
        <meta name="keywords" content="Columbiaa Hospital services, hospital services, multi-speciality hospital services, 24x7 emergency care, critical care services, dialysis services, digital X-ray, advanced laboratory, pharmacy services, insurance desk, front desk, patient care services, hospital in Kasturi Nagar, hospital in Bangalore, best hospital services, emergency hospital Bangalore, critical care hospital, dialysis center Bangalore, lab services Bangalore, insurance TPA, cashless treatment, medical services Bangalore, healthcare services, hospital near me, top hospital Bangalore, multi-speciality hospital near me, Columbiaa Hospital Kasturi Nagar, neurosurgery services, brain surgery services, spine surgery services, cardiology services, orthopedics services, neurology services" />
        <meta name="author" content="Columbiaa Hospital" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Columbiaa Hospital Services | Best Multi-Speciality Hospital in Kasturi Nagar Bangalore" />
        <meta property="og:description" content="Columbiaa Hospital offers comprehensive medical services in Kasturi Nagar, Bangalore. 24x7 emergency care, critical care, dialysis, digital X-ray, advanced laboratory, and expert doctors." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://columbiaahospital.com/services" />
        <meta property="og:site_name" content="Columbiaa Hospital" />
        <meta property="og:locale" content="en_IN" />
        <link rel="canonical" href="https://columbiaahospital.com/services" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "MedicalOrganization",
              "name": "Columbiaa Hospital",
              "url": "https://columbiaahospital.com",
              "logo": "https://columbiaahospital.com/assets/images/zclogo.png",
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+91-8548979899",
                "contactType": "appointments",
                "areaServed": "IN",
                "availableLanguage": ["English", "Hindi", "Kannada"]
              },
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Building No 06, 5th Main Rd, B Channasandra, OMBR Layout",
                "addressLocality": "Bengaluru",
                "addressRegion": "Karnataka",
                "postalCode": "560043",
                "addressCountry": "IN"
              },
              "sameAs": [
                "https://www.facebook.com/share/1BFLVsneD2/",
                "https://x.com/columbiaahosp",
                "https://www.linkedin.com/in/columbiaa-hospital-kasturi-nagar-bengaluru-98aa37323/",
                "https://www.instagram.com/columbiaahospital/",
                "https://www.youtube.com/@columbiaahospital"
              ]
            }
          `}
        </script>
      </Helmet>
      <div>
      {/* <!--Page Title--> */}
      <section
        class="page-title"
        style={{
          backgroundImage: "url(assets/images/background/page-title-2.jpg)",
          overflowX: "hidden",
        }}
      >
        <div
          class="pattern-layer"
          style={{
            backgroundImage: "url(assets/images/shape/pattern-35.png)",
          }}
        ></div>
        <div class="auto-container">
          <div class="content-box">
            {/* <!-- contactinfo-section --> */}
            <section class="contact-page-section">
              <div class="auto-container">
                <div class="row clearfix " style={{ marginTop: "-150px" }}>
                  <div
                    class="col-lg-6 col-md-12 col-sm-12 content-column "
                    style={{ marginTop: "30px" }}
                  >
                    <div
                      id="content_block_6"
                      data-aos="fade-right"
                      aria-label="Welcome to Columbiaa Hospital, Kasturi Nagar Section"
                    >
                      <div className="content-box">
                        <div className="sec-title mt-5">
                          <h3
                            style={{ color: "white", fontWeight: "600" }}
                            aria-label="Welcome message to Columbiaa Hospital, Kasturi Nagar"
                            itemProp="headline"
                          >
                            Welcome to{" "}
                            <strong itemProp="name">Columbiaa Hospital</strong>
                          </h3>
                          <p
                            style={{ color: "white" }}
                            aria-label="Introduction to Columbiaa Hospital, Kasturi Nagar"
                            itemProp="description"
                          >
                            At{" "}
                            <strong itemProp="name">
                              Columbiaa Hospital, Kasturi Nagar
                            </strong>
                            , we are dedicated to providing exceptional
                            healthcare with a personal touch. Our
                            state-of-the-art facilities and expert team offer a
                            full spectrum of services, from emergency care to
                            specialized treatments, ensuring your well-being
                            every step of the way. Trust us to deliver the
                            highest standard of care for you and your loved
                            ones.
                          </p>
                          <br /> <br /> <br />
                          <div className="row ml-1 pb-2">
                            <Link
                              to="/contacts"
                              className="class_link"
                              title="Contact Columbiaa Hospital, Kasturi Nagar"
                            >
                              <div
                                className="btn p-3 m-1 bg-success"
                                aria-label="Talk to Our Doctor link"
                              >
                                <a
                                  className="text-white"
                                  href="/doctors"
                                  title="Talk to Our Doctor at Columbiaa Hospital, Kasturi Nagar"
                                >
                                  Talk to Our Doctor
                                </a>
                              </div>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-lg-6 col-md-12 col-sm-12 form-column"
                    data-aos="fade-left"
                  >
                    <div
                      className="form-inner"
                      style={{
                        borderRadius: "12px",
                        padding: "20px",
                      }}
                      aria-label="Columbiaa Hospital Services"
                    >
                      <img
                        src="assets/images/service/ot1.jpeg"
                        alt="Columbiaa Hospital Services - Operating Theatre"
                        title="Columbiaa Hospital Operating Theatre"
                        aria-label="Operating theatre services at Columbiaa Hospital"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
            {/* <!-- contactinfo-section end --> */}
          </div>
        </div>
      </section>
      {/* <!--End Page Title--> */}

      {/* <!-- service-section --> */}
      <section
        class="service-section service-page"
        style={{ overflowX: "hidden", overflowY: "hidden" }}
      >
        <div class="anim-icon">
          <div
            class="icon-1"
            style={{
              backgroundImage: "url(assets/images/icons/anim-icon-1.png)",
            }}
          ></div>
          <div class="icon-2"></div>
        </div>
        <div class="auto-container">
          <div
            className="sec-title centred"
            data-aos="fade-right"
            aria-label="Columbiaa Hospital Services Section"
          >
            <h2 itemProp="headline">Services We Provide</h2>
            <p itemProp="description">
              At <strong itemProp="name">Columbiaa Hospital</strong>, our expert
              team delivers exceptional, personalized healthcare with
              state-of-the-art facilities, ensuring your well-being 24/7.
            </p>
          </div>

          <div class="row clearfix">
            <div className="col-lg-4 col-md-6 col-sm-12 service-block">
              <div className="service-block-one">
                <div
                  className="inner-box"
                  role="region"
                  aria-label="Columbiaa Hospital Insurance Desk Services"
                >
                  <div
                    itemScope
                    itemType="https://schema.org/MedicalOrganization"
                  >
                    <figure className="image-box" data-aos="fade-down-right">
                      <img
                        src="assets/images/service/insurance.jpeg"
                        alt="Patient-friendly insurance services at Columbiaa Hospital"
                        itemProp="image"
                      />
                    </figure>

                    <div className="lower-content" data-aos="fade-down-left">
                      <div className="content-box">
                        <div className="inner">
                          <figure className="icon-box">
                            <img
                              src="assets/images/icons/icon-61.png"
                              alt="Icon representing front office services at Columbiaa Hospital"
                              itemProp="logo"
                            />
                          </figure>
                          <h4 itemProp="department">
                            Patient Friendly Front Desk
                          </h4>
                        </div>
                        <div className="link">
                          <a
                            href="/contacts"
                            aria-label="More about Columbiaa Hospital's Front Desk"
                            itemProp="url"
                          >
                            More Details
                          </a>
                        </div>
                      </div>

                      <div className="overlay-content" itemProp="description">
                        <p>
                          We offer a dedicated Front Office Hospital Desk to
                          simplify your admission and registration process. Our
                          friendly team supports you with daily OP
                          consultations, payment queries, and coverage
                          assistance, ensuring a smooth and stress-free
                          experience.
                        </p>

                        <a
                          href="/contacts"
                          aria-label="More details on Columbiaa Hospital Insurance Desk"
                        >
                          <i
                            className="flaticon-right-arrow"
                            aria-hidden="true"
                          ></i>
                          More details
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12 service-block mb-5">
              <div className="service-block-one">
                <div
                  className="inner-box"
                  role="region"
                  aria-label="Columbiaa Hospital 24x7 Accident and Emergency Services"
                >
                  <div itemScope itemType="https://schema.org/Hospital">
                    <figure className="image-box" data-aos="fade-down-right">
                      <img
                        src="assets/images/service/service1.jpeg"
                        alt="Emergency care at Columbiaa Hospital"
                        itemProp="image"
                      />
                    </figure>

                    <div className="lower-content" data-aos="fade-down-left">
                      <div className="content-box">
                        <div className="inner">
                          <figure className="icon-box">
                            <img
                              src="assets/images/icons/icon-4.png"
                              alt="Emergency medical services icon at Columbiaa Hospital"
                              itemProp="logo"
                            />
                          </figure>
                          <h4 itemProp="department">
                            24×7 Accident and Emergency
                          </h4>
                        </div>
                        <div className="link">
                          <a
                            href="/contacts"
                            aria-label="More about Columbiaa Hospital Emergency Services"
                            itemProp="url"
                          >
                            More Details
                          </a>
                        </div>
                      </div>

                      <div className="overlay-content" itemProp="description">
                        <p>
                          We provide round-the-clock emergency care for
                          accidents and urgent medical needs. Our skilled team
                          and advanced facilities are ready 24/7 to deliver
                          rapid, life-saving treatment when every second counts.
                        </p>
                        <a
                          href="/contacts"
                          aria-label="More details about Columbiaa Hospital’s Emergency Department"
                        >
                          <i
                            className="flaticon-right-arrow"
                            aria-hidden="true"
                          ></i>
                          More details
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12 service-block mb-5">
              <div className="service-block-one">
                <div
                  className="inner-box"
                  role="region"
                  aria-label="Columbiaa Hospital 24x7 Pharmacy Services"
                >
                  <div itemScope itemType="https://schema.org/Pharmacy">
                    <figure className="image-box" data-aos="fade-down-right">
                      <img
                        src="assets/images/service/service2.jpg"
                        alt="24x7 Pharmacy at Columbiaa Hospital"
                        itemProp="image"
                      />
                    </figure>

                    <div className="lower-content" data-aos="fade-down-left">
                      <div className="content-box">
                        <div className="inner">
                          <figure className="icon-box">
                            <img
                              src="assets/images/icons/icon-5.png"
                              alt="Icon representing Columbiaa Hospital pharmacy services"
                              itemProp="logo"
                            />
                          </figure>
                          <h4 itemProp="name">24×7 Pharmacy Services</h4>
                        </div>
                        <div className="link">
                          <a
                            href="/contacts"
                            aria-label="More about Columbiaa Hospital’s 24x7 Pharmacy"
                            itemProp="url"
                          >
                            More Details
                          </a>
                        </div>
                      </div>

                      <div className="overlay-content" itemProp="description">
                        <p>
                          Our pharmacy ensures uninterrupted access to essential
                          medicines and professional advice. Our skilled
                          pharmacists provide accurate prescriptions, guidance
                          on medication use, and exceptional care—day and night.
                        </p>
                        <a
                          href="/contacts"
                          aria-label="More details about Columbiaa Hospital Pharmacy Services"
                        >
                          <i
                            className="flaticon-right-arrow"
                            aria-hidden="true"
                          ></i>
                          More details
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12 service-block mb-5 mt-5">
              <div className="service-block-one">
                <div
                  className="inner-box"
                  role="region"
                  aria-label="Columbiaa Hospital Critical Care Services"
                >
                  <div
                    itemScope
                    itemType="https://schema.org/MedicalOrganization"
                  >
                    <figure className="image-box" data-aos="fade-down-right">
                      <img
                        src="assets/images/service/service3.jpeg"
                        alt="24/7 Critical Care Services at Columbiaa Hospital"
                        itemProp="image"
                      />
                    </figure>

                    <div className="lower-content" data-aos="fade-down-left">
                      <div className="content-box">
                        <div className="inner">
                          <figure className="icon-box">
                            <img
                              src="assets/images/icons/icon-6.png"
                              alt="Icon representing critical care services at Columbiaa Hospital"
                              itemProp="logo"
                            />
                          </figure>
                          <h4 itemProp="department">
                            Round the Clock Critical Care Team
                          </h4>
                        </div>
                        <div className="link">
                          <a
                            href="/contacts"
                            aria-label="More about Columbiaa Hospital's Critical Care Team"
                            itemProp="url"
                          >
                            More Details
                          </a>
                        </div>
                      </div>

                      <div className="overlay-content" itemProp="description">
                        <p>
                          <strong itemProp="name">Columbiaa Hospital</strong>{" "}
                          provides 24/7 expert-led critical care services. Our
                          experienced medical professionals and advanced
                          monitoring systems deliver continuous, life-saving
                          treatment for patients in critical condition.
                        </p>
                        <a
                          href="/contacts"
                          aria-label="More details on Columbiaa Hospital Critical Care Services"
                        >
                          <i
                            className="flaticon-right-arrow"
                            aria-hidden="true"
                          ></i>
                          More details
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12 service-block mt-5">
              <div className="service-block-one">
                <div
                  className="inner-box"
                  role="region"
                  aria-label="Columbiaa Hospital Insurance Desk Services"
                >
                  <div
                    itemScope
                    itemType="https://schema.org/MedicalOrganization"
                  >
                    <figure className="image-box" data-aos="fade-down-right">
                      <img
                        src="assets/images/service/insurance1.jpeg"
                        alt="Patient-friendly insurance services at Columbiaa Hospital"
                        itemProp="image"
                      />
                    </figure>

                    <div className="lower-content" data-aos="fade-down-left">
                      <div className="content-box">
                        <div className="inner">
                          <figure className="icon-box">
                            <img
                              src="assets/images/icons/icon-61.png"
                              alt="Icon representing insurance services at Columbiaa Hospital"
                              itemProp="logo"
                            />
                          </figure>
                          <h4 itemProp="department">
                            Patient Friendly Insurance Desk
                          </h4>
                        </div>
                        <div className="link">
                          <a
                            href="/contacts"
                            aria-label="More about Columbiaa Hospital's Insurance Desk"
                            itemProp="url"
                          >
                            More Details
                          </a>
                        </div>
                      </div>

                      <div className="overlay-content" itemProp="description">
                        <p>
                          <strong itemProp="name">Columbiaa Hospital</strong>{" "}
                          offers a dedicated insurance desk to simplify your
                          billing process. Our friendly team supports you with
                          insurance claims, payment queries, and coverage
                          assistance, ensuring a stress-free experience.
                        </p>
                        <a
                          href="/contacts"
                          aria-label="More details on Columbiaa Hospital Insurance Desk"
                        >
                          <i
                            className="flaticon-right-arrow"
                            aria-hidden="true"
                          ></i>
                          More details
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12 service-block mt-5">
              <div
                className="service-block-one"
                role="region"
                aria-label="Columbiaa Hospital Digital X-ray Services"
              >
                <div
                  className="inner-box"
                  itemScope
                  itemType="https://schema.org/MedicalOrganization"
                >
                  <figure className="image-box" data-aos="fade-down-right">
                    <img
                      src="assets/images/service/service5.jpeg"
                      alt="Digital X-ray services at Columbiaa Hospital"
                      itemProp="image"
                    />
                  </figure>

                  <div className="lower-content" data-aos="fade-down-left">
                    <div className="content-box">
                      <div className="inner">
                        <figure className="icon-box">
                          <img
                            src="assets/images/icons/icon-62.png"
                            alt="Icon representing Digital X-ray at Columbiaa Hospital"
                            itemProp="logo"
                          />
                        </figure>
                        <h4 itemProp="department">Digital X-ray Services</h4>
                      </div>
                      <div className="link">
                        <a
                          href="/contacts"
                          aria-label="Learn more about Columbiaa Hospital's Digital X-ray Services"
                          itemProp="url"
                        >
                          More Details
                        </a>
                      </div>
                    </div>

                    <div className="overlay-content" itemProp="description">
                      <p>
                        <strong itemProp="name">Columbiaa Hospital</strong>{" "}
                        offers advanced digital X-ray services for fast,
                        high-quality imaging. Our modern technology ensures
                        accurate diagnostics with minimal radiation exposure,
                        aiding in swift and effective treatment planning.
                      </p>
                      <a
                        href="/contacts"
                        aria-label="More about Columbiaa Hospital's Digital X-ray Services"
                      >
                        <i
                          className="flaticon-right-arrow"
                          aria-hidden="true"
                        ></i>
                        More details
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12 service-block mt-5">
              <div className="service-block-one">
                <div className="inner-box">
                  <figure className="image-box" data-aos="fade-down-right">
                    <img
                      src="assets/images/service/service6.jpeg"
                      alt="Columbiaa Hospital Services"
                    />
                  </figure>
                  <div
                    className="lower-content"
                    data-aos="fade-down-left"
                    role="region"
                    aria-label="Columbiaa Hospital Laboratory Services"
                  >
                    <div
                      className="content-box"
                      itemScope
                      itemType="https://schema.org/MedicalOrganization"
                    >
                      <div className="inner">
                        <figure className="icon-box">
                          <img
                            src="assets/images/icons/icon-63.png"
                            alt="Icon representing Columbiaa Hospital's advanced laboratory services"
                            itemProp="image"
                          />
                        </figure>
                        <h4 itemProp="department">Advanced Laboratory</h4>
                      </div>
                      <div className="link">
                        <a
                          href="/contacts"
                          aria-label="More details about Columbiaa Hospital Laboratory Services"
                          itemProp="url"
                        >
                          More Details
                        </a>
                      </div>
                    </div>

                    <div className="overlay-content" itemProp="description">
                      <p>
                        At <strong itemProp="name">Columbiaa Hospital</strong>,
                        our cutting-edge laboratory delivers precise and timely
                        diagnostic results. Equipped with the latest technology,
                        our skilled team conducts a wide range of tests for all
                        required.
                      </p>
                      <a
                        href="/contacts"
                        aria-label="Read more about Columbiaa Hospital lab services"
                      >
                        <i
                          className="flaticon-right-arrow"
                          aria-hidden="true"
                        ></i>
                        More details
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12 service-block mt-5">
              <div className="service-block-one">
                <div className="inner-box">
                  <figure className="image-box" data-aos="fade-down-right">
                    <img
                      src="assets/images/service/dialysis1.jpeg"
                      alt="Columbiaa Hospital Dialysis Services"
                    />
                  </figure>
                  <div
                    className="lower-content"
                    data-aos="fade-down-left"
                    role="region"
                    aria-label="Columbiaa Hospital Dialysis Services"
                  >
                    <div
                      className="content-box"
                      itemScope
                      itemType="https://schema.org/MedicalOrganization"
                    >
                      <div className="inner">
                        <figure className="icon-box">
                          <img
                            src="assets/images/icons/icon-63.png"
                            alt="Icon representing Columbiaa Hospital's dialysis services"
                            itemProp="image"
                          />
                        </figure>
                        <h4 itemProp="department">Dialysis Services</h4>
                      </div>
                      <div className="link">
                        <a
                          href="/contacts"
                          aria-label="More details about Columbiaa Hospital Dialysis Services"
                          itemProp="url"
                        >
                          More Details
                        </a>
                      </div>
                    </div>

                    <div className="overlay-content" itemProp="description">
                      <p>
                        <strong itemProp="name">Columbiaa Hospital</strong>{" "}
                        provides advanced Dialysis Services with a focus on
                        patient safety and comfort. Our specialised team
                        delivers high-quality renal care using modern equipment
                        in a hygienic, compassionate setting.
                      </p>
                      <a
                        href="/contacts"
                        aria-label="Read more about Columbiaa Hospital Dialysis Services"
                      >
                        <i
                          className="flaticon-right-arrow"
                          aria-hidden="true"
                        ></i>
                        More details
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12 service-block mt-5">
              <div className="service-block-one">
                <div className="inner-box">
                  <figure className="image-box" data-aos="fade-down-right">
                    <img
                      src="assets/images/service/wards.png"
                      alt="Columbiaa Hospital Ward Facilities"
                    />
                  </figure>
                  <div
                    className="lower-content"
                    data-aos="fade-down-left"
                    role="region"
                    aria-label="Columbiaa Hospital Ward Facilities"
                  >
                    <div
                      className="content-box"
                      itemScope
                      itemType="https://schema.org/MedicalOrganization"
                    >
                      <div className="inner">
                        <figure className="icon-box">
                          <img
                            src="assets/images/icons/icon-63.png"
                            alt="Icon representing Columbiaa Hospital's patient wards"
                            itemProp="image"
                          />
                        </figure>
                        <h4 itemProp="department">Patient Wards</h4>
                      </div>
                      <div className="link">
                        <a
                          href="/contacts"
                          aria-label="More details about Columbiaa Hospital Patient Wards"
                          itemProp="url"
                        >
                          More Details
                        </a>
                      </div>
                    </div>

                    <div className="overlay-content" itemProp="description">
                      <p>
                        <strong itemProp="name">Columbiaa Hospital</strong>{" "}
                        offers clean, spacious, and well-equipped wards designed
                        to ensure maximum comfort and care. Our wards are
                        staffed round-the-clock by trained professionals,
                        prioritising safety, hygiene, and patient wellbeing.
                      </p>
                      <a
                        href="/contacts"
                        aria-label="Read more about Columbiaa Hospital Ward Facilities"
                      >
                        <i
                          className="flaticon-right-arrow"
                          aria-hidden="true"
                        ></i>
                        More details
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- service-section end --> */}

      <ContactMarquee />
      <Specialities />
    </div>
    </>
  );
};

export default Services;
